import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GATrackingEventType, GaTrackingEventName } from '../../constants';

export class GATrackingPromoImageLinkClickEvent implements GATrackingEvent {
  constructor(private payload: any) {}

  getEventType(): GATrackingEventType {
    return GATrackingEventType.PromoImageLinkClick;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.PromoImageLinkClick,
      label: this.payload.label,
      gtmCustom: {
        'content-name': this.payload.gtmCustom['content-name'],
      },
    };
  }
}
